module.exports = __webpack_public_path__ + "img/logo-colegiados.d9c26cc8.svg";